import produce from "immer";
import styled, { css } from "styled-components";
import { Radio } from "antd";
import { Controller } from "react-hook-form";
import SelectedColorSelect from "./selectedColorSelect";
import { CustomPlainDivider } from "../HotStampingRadio";

function PrintColorRadio(props) {
  const {
    name,
    control,
    setValue,
    errors,
    trigger,
    fields,
    getValues,
    reset,
    watch,
  } = props;
  return (
    <>
      <CustomPlainDivider orientation="left" plain>
        Print Color
      </CustomPlainDivider>
      {fields.map((item, index) => {
        return (
          <PrintColorContainer key={item.id}>
            <div>
              <Controller
                control={control}
                defaultValue={item.type}
                name={`${name}.print_color[${index}].type`}
                render={({ onChange, onBlur, value }) => {
                  return (
                    <StyledRadioGroup
                      error={
                        errors && errors[`${name}.print_color[${index}].type`]
                      }
                      size={"medium"}
                      options={["1 Color", "2 Color", "4 Color"]}
                      defaultValue={item.type}
                      onChange={(e) => {
                        setValue(
                          `${name}.print_color[${index}].type`,
                          e.target.value,
                          {
                            shouldDirty: true,
                          }
                        );
                        trigger(`${name}.print_color[${index}].type`);
                        console.log(
                          "cover.hot_stamping :>> ",
                          watch("cover.hot_stamping")
                        );
                        if (e.target.value === "1 Color") {
                          const printColor = produce(watch(), (draft) => {
                            draft[name].print_color[index].selected_color = [
                              {
                                type: "CMYK",
                                color: "BLACK",
                              },
                            ];
                            draft.cover.hot_stamping = watch(
                              "cover.hot_stamping"
                            );
                          });
                          reset(printColor, { errors: true });
                        } else if (e.target.value === "2 Color") {
                          const printColor = produce(getValues(), (draft) => {
                            draft[name].print_color[index].selected_color = [
                              {
                                type: "CMYK",
                                color: null,
                              },
                              {
                                type: "CMYK",
                                color: null,
                              },
                            ];
                            draft.cover.hot_stamping = watch(
                              "cover.hot_stamping"
                            );
                          });
                          // draft.cover.hot_stamping = watch(cover.hot_stamping) || []
                          reset(printColor, { errors: true });
                        } else if (e.target.value === "4 Color") {
                          const printColor = produce(watch(), (draft) => {
                            draft[name].print_color[index].selected_color = [
                              {
                                type: "CMYK",
                                color: "CYAN",
                              },
                              {
                                type: "CMYK",
                                color: "MAGENTA",
                              },
                              {
                                type: "CMYK",
                                color: "YELLOW",
                              },
                              {
                                type: "CMYK",
                                color: "BLACK",
                              },
                            ];
                            draft.cover.hot_stamping = watch(
                              "cover.hot_stamping"
                            );
                          });

                          reset(printColor, { errors: true });
                        }
                      }}
                    />
                  );
                }}
              />
              <SelectedColorContainer>
                <SelectedColorSelect
                  setValue={setValue}
                  control={control}
                  printColorIndex={index}
                  name={name}
                  errors={errors}
                  trigger={trigger}
                  watch={watch}
                  reset={reset}
                  getValues={getValues}
                />
              </SelectedColorContainer>
            </div>
          </PrintColorContainer>
        );
      })}
    </>
  );
}

const StyledRadioGroup = styled(Radio.Group)`
  .ant-radio-button-wrapper {
    margin-top: ${(props) => props.theme.spacing[1]};
  }
  ${(props) =>
    props.error &&
    css`
      .ant-radio-button-wrapper {
        border: 1px solid ${(props) => props.theme.colors.red[600]};
        color: ${(props) => props.theme.colors.red[600]};
      }
    `};
`;

const PrintColorContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${(props) => props.theme.spacing[2]};
  border: 2px solid ${(props) => props.theme.colors.grey[200]};
`;

const SelectedColorContainer = styled.div`
  margin-top: ${(props) => props.theme.spacing[1]};
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export default PrintColorRadio;
